import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom/dist';
import apiUrl from '../Environment/Api';

function Login() {
    const navigate = useNavigate();

    const [formData, setformData] = useState({
        'email': '',
        'password': ''
    })

    axios.defaults.withCredentials = true;

    const [message, setMessage] = useState('')
    const handlesubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(apiUrl + '/login', formData);
            console.log('Login response:', response.data);
            if (response.data.status === 'success') {
                const token = response.data.token;
                localStorage.setItem('token', token);
                navigate('/dashboard');
                window.location.reload();
            } else {
                setMessage(response.data.message);
                console.log('Login failed:', response.data.message);
            }
        } catch (error) {
            alert('An error occurred while logging in. Please try again later.');
            console.error('Login error:', error);
        }
    }

    return (
        <div>
            <div class="container-scroller ">
                <div class="page-body-wrapper full-page-wrapper backgroundimage">
                    <div class="content-wrapper d-flex align-items-center auth">
                        <div class="row flex-grow">
                            <div class="col-lg-12 mx-auto">
                                <div class="auth-form-light text-left p-5">
                                    <div class="brand-logo">
                                        {/* <h3>VAS PRODUCTION</h3> */}
                                        <img src={require('../../assets/img/Admin/Logo.png')} alt='images' />
                                    </div>

                                    <form onSubmit={handlesubmit} className="pt-3">
                                        <div className="form-group">
                                            <label>Username</label>
                                            <input

                                                className="form-control form-control-lg"
                                                id="exampleInputEmail1"
                                                value={formData.email}
                                                onChange={(e) => setformData({ ...formData, email: e.target.value })}
                                                placeholder="Username"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Password</label>
                                            <input
                                                type="password"
                                                className="form-control form-control-lg"
                                                id="exampleInputPassword1"
                                                value={formData.password}
                                                onChange={(e) => setformData({ ...formData, password: e.target.value })}
                                                placeholder="Password"
                                            />
                                        </div>
                                        <p>{message}</p>
                                        <div className="mt-3 login-button">
                                            <button className="btn text-white bg-primary  btn-lg font-weight-medium auth-form-btn">
                                                SIGN IN
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!-- content-wrapper ends --> */}
                </div>
                {/* <!-- page-body-wrapper ends --> */}
            </div>

        </div>
    )
}

export default Login